// Links externos oficiais do Dr. Matheus Lopes (extraídos do Linktree)
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/drmatheuslopesneuro/",
  whatsapp:
    "https://wa.me/5511930764101?text=Ol%C3%A1!%20Estou%20vindo%20pelo%20blog%20NeuroSa%C3%BAde%20e%20gostaria%20de%20agendar%20uma%20consulta%20com%20o%20Dr.%20Matheus%20Lopes.",
  youtube: "https://www.youtube.com/@drmatheuslopesneuro",
  linktree: "https://linktr.ee/drmatheuslopesneuro",
  website: "http://www.drmatheuslopes.com.br/",
  maps: "https://goo.gl/maps/emSVe6agP1bntTwZA",
  fellowship:
    "https://docs.google.com/forms/d/e/1FAIpQLSd4MRgN4MlMiqlUW9y2IFp-gugvtA26sO40SY4ViAPHVQTtzQ/viewform?usp=sf_link",
  folha: "https://folha.com/mio5pr7q",
  email: "contato@drmatheuslopes.com.br",
};
